import { render, staticRenderFns } from "./callbackrecordtable.vue?vue&type=template&id=e3208576&scoped=true&"
import script from "./callbackrecordtable.vue?vue&type=script&lang=js&"
export * from "./callbackrecordtable.vue?vue&type=script&lang=js&"
import style0 from "./callbackrecordtable.vue?vue&type=style&index=0&id=e3208576&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3208576",
  null
  
)

export default component.exports